var DT = require("../DataTable/DataTable");
var DG = require("../DataGraph/DataGraph");

var DataProcessor = {};
var DP_Private = {};

DP_Private.graphType = function(meta) {
    var str = JSON.stringify(meta.chart.type);
    metaGraphType = str.replace(/^"|"$/g, '');
    return metaGraphType;
};

DP_Private.graphStructure = function(type, meta, data) {
    return DG.extractStructure(type, meta, data);
};

DP_Private.graphData = function(type, meta, data) {
    return DG.extractData(type, meta, data);
};

DP_Private.tableStructure = function(meta, data) {
    return DT.extractStructure(meta, data);
};

DP_Private.tableData = function(meta, data) {
    return DT.extractData(meta, data);
};

DataProcessor.proces = function(meta, data) {
    var type = DP_Private.graphType(meta);
    var gStruc = DP_Private.graphStructure(type, meta, data);
    var gData = DP_Private.graphData(type, meta, data);
    var tStruc = DP_Private.tableStructure(meta, data);
    var tData = DP_Private.tableData(meta, data);

    return {
        "type": type,
        "graphStructure": gStruc,
        "graphData": gData,
        "tableStructure": tStruc,
        "tableData": tData,
    };
};

module.exports = DataProcessor;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataProcessor/DataProcessor.js
// module id = 2
// module chunks = 0